export enum PracticeTaxIdType {
    EIN = "EI",
    SSN = "SY",
}

export enum UpdateUsersInGroupOperation {
    ADD = "ADD",
    REMOVE = "REMOVE",
}

export enum PracticePayerMappingsMode {
    PASSTHROUGH = "PASSTHROUGH",
    MANAGED = "MANAGED",
}

// Case-sensitive; used for query param in the payer-service request
export enum PracticePayerMappingsBulkMode {
    ADDITIVE = "additive",
    REPLACE = "replace",
}

export enum PracticeWorkflowManagementVersion {
    DEFAULT = "DEFAULT",
    EXTENDED_CUSTOM_FIELDS = "EXTENDED_CUSTOM_FIELDS",
    MEDICAID = "MEDICAID",
}

export const COMMON_PRACTICE_CONFIG = {
    defaultTaxIdType: PracticeTaxIdType.EIN,
}
